import { Reveal } from "@/components/Reveal";

const FAILURES = [
  "HESITATION",
  "OVERTRADING",
  "STRATEGY HOPPING",
  "MOVING STOPS",
  "TAKING PROFITS TOO EARLY",
  "HOLDING LOSERS TOO LONG",
  "EMOTIONAL DECISION-MAKING",
];

export default function Problem() {
  return (
    <section data-testid="problem-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-start gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal>
              <div className="mb-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-neon/90">
                <span className="h-px w-8 bg-neon/50" />
                01 — The Problem
              </div>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
                You don't need another strategy.
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <h2 className="mt-2 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl">
                <span className="text-white">You need </span>
                <span className="glow-text-neon text-neon">better execution.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.24}>
              <p className="mt-7 max-w-lg text-base leading-relaxed text-mist">
                Most traders already know enough to enter a trade. The real
                breakdown often happens between knowing what to do and
                consistently executing it.
              </p>
            </Reveal>
          </div>

          <div className="panel rounded-lg p-6 sm:p-8">
            <Reveal>
              <div className="mb-6 font-mono text-[10px] uppercase tracking-[0.25em] text-dim">
                Where execution breaks down
              </div>
            </Reveal>
            <div className="flex flex-wrap gap-2.5">
              {FAILURES.map((f, i) => (
                <Reveal key={f} delay={0.05 * i}>
                  <span className="inline-block rounded-md border border-line bg-ink px-3.5 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-mist transition-colors duration-300 hover:border-risk/50 hover:text-risk">
                    {f}
                  </span>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-20 border-t border-line pt-14 sm:mt-24">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-dim">
              P.E.E. was built around one objective
            </p>
            <h3 className="mt-4 max-w-4xl font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-white sm:text-5xl">
              Turn <span className="text-neon">execution</span> into a process.
            </h3>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
